module.exports = __webpack_public_path__ + "img/LOGO_endpage.ebf0add9.png";